import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import FF_Header from '../assets/header/FF_Header.svg'
import FF_logo_2 from '../assets/header/FF_logo_2.svg'
import icon_facebook from '../assets/header/icon_facebook.svg'
import icon_instagram from '../assets/header/icon_instagram.svg'
import incon_youtube from '../assets/header/incon_youtube.svg'
import icon_tiktok from '../assets/header/Tiktok.svg'
import arrow_down from '../assets/header/arrow_down.svg'
import getActivePage from "../scripts/activePage";

const activePage = getActivePage();

function Header() {

    const location = useLocation();
    const isCuisineLocative = location.pathname.toLowerCase().includes('cuisinelocative');
    const facebookUrl = isCuisineLocative
        ? 'https://www.facebook.com/CuisineLocativeSherbrooke'
        : 'https://www.facebook.com/FerventFerment';

    const [menuOpen, setMenuOpen] = useState(false);
    const [FFOpen, setFFOpen] = useState(false);
    const [headerVisible, setHeaderVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isAtTop, setIsAtTop] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            
            // Track if at top of page
            setIsAtTop(currentScrollY < 50);
            
            if (currentScrollY < lastScrollY || currentScrollY < 100) {
                // Scrolling up or near top - show header
                setHeaderVisible(true);
            } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
                // Scrolling down - hide header
                setHeaderVisible(false);
            }
            
            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
        if (document.body.style.overflow === 'hidden') {
            document.body.style.overflow = 'visible'
        } else {
            document.body.style.overflow = 'hidden'
        }
    };

    const toggleFF = () => {
        setFFOpen(!FFOpen);
    };

    return (
        <>
            <div id="headerWrapper" className={`${FFOpen ? 'open' : 'close'} ${headerVisible ? 'header-visible' : 'header-hidden'} ${isAtTop ? '' : 'scrolled'}`}>
                <a className="aSize" id="headerLeafLogo" href="/"><img src={FF_logo_2} alt="Feuille Fervent Ferment" /></a>
                <img className={`headerCentralLogo ${isAtTop ? 'at-top' : 'scrolled'}`} src={FF_Header} alt="Fervent Ferment Lactofermentation" />
                <div
                    id='menuButton'
                    className={`button ${menuOpen ? 'buttonOpen' : 'buttonClose'}`}
                    onClick={toggleMenu}
                >
                    <div className='line'></div>
                    <div className='line'></div>
                    <div className='line'></div>
                </div>
                <div id='mobileNav' className={`${menuOpen ? 'open' : 'close'}`}>
                    <ul>
                        <li > <a className={`${activePage === '' ? 'active' : ''}`} href="/">Acceuil</a></li>
                        <div id="menuFF">
                            <li className={`fontDongle hoverFF ${activePage === 'traiteur' || activePage === 'atelier' ? 'headerFFGreen' : ''}`} onClick={toggleFF}>Fervent Ferment</li>
                            <img
                                id="arrow_down"
                                className={`mobileHidden ${menuOpen ? 'buttonOpen' : 'buttonClose'} ${FFOpen ? 'open' : 'close'}`}
                                onClick={toggleFF}
                                src={arrow_down}
                                alt="FerventFerment open arrow"
                            />
                            <div id="sublistWrapper" className={`${FFOpen ? 'open' : 'close'}`}>
                                <li className="sublist"><a href="https://ferventferment.square.site/shop/boutiqueferment/14" target="_blank" rel="noreferrer">Boutique</a></li>
                                <li className="sublist"><a href="https://ferventferment.square.site/atelier" target="_blank" rel="noreferrer">Ateliers</a></li>
                                <li className="sublist"><a href="https://ferventferment.square.site/traiteur-personnalise" target="_blank" rel="noreferrer">Traiteur</a></li>
                                <li className="sublist"><a href="https://ferventferment.square.site/product/le-club-de-fermentation-fervent-ferment/39?cp=true&sa=false&sbp=false&q=false&category_id=18" target="_blank" rel="noreferrer">Club</a></li>
                                <li className="sublist"><a href="https://ferventferment.square.site/recettes" target="_blank" rel="noreferrer">Recettes</a></li>
                            </div>
                        </div>
                        <li id='cuisineLocative' ><a className={`fontCookie hoverCuisineLocative ${activePage === 'cuisinelocative' ? 'active' : ''}`} href="/cuisinelocative">Cuisine <span className={`fontCookie hoverCuisineLocative border-bottom ${activePage === 'cuisinelocative' ? 'active' : ''}`}>Locative</span></a></li>
                        <li><a className={`${activePage === 'a-propos' ? 'active' : ''}`} href="/a-propos">À propos</a></li>
                        <li id="granolaNav"><a className={`${activePage === 'financement' ? 'active' : ''}`} href="https://ferventferment.square.site/granola-personnalise" target="_blank" rel="noopener noreferrer">Granola<br /><span id="granolaUnderline">Personalisé</span></a></li>
                        <li><a className={`${activePage.includes('contact') ? 'active' : ''}`} href="/contact">Contact</a></li>
                        <div id="social" className="socialMobile">
                            <a className="iconNotUnderline" href={facebookUrl} target='_blank' rel='noreferrer'><img id="headerSocial_facebook" src={icon_facebook} alt="Facebook" /></a>
                            <a className="iconNotUnderline" href="https://www.instagram.com/ferventferment" target='_blank' rel='noreferrer'><img id="headerSocial_instagram" src={icon_instagram} alt="Instagram" /></a>
                            <a className="iconNotUnderline" href="https://www.youtube.com/@FerventFerment" target='_blank' rel='noreferrer'><img id="headerSocial_youtube" src={incon_youtube} alt="YouTube" /></a>
                            <a className="iconNotUnderline" href="https://www.tiktok.com/@ferventferment" target='_blank' rel='noreferrer'><img id="headerSocial_tiktok" src={icon_tiktok} alt="TikTok" /></a>
                        </div>
                    </ul>
                    <div id="socialDesktop" className="socialDesktop">
                        <a className="iconNotUnderline" href={facebookUrl} target='_blank' rel='noreferrer'><img className="headerSocial_facebook" src={icon_facebook} alt="Facebook" /></a>
                        <a className="iconNotUnderline" href="https://www.instagram.com/ferventferment" target='_blank' rel='noreferrer'><img className="headerSocial_instagram" src={icon_instagram} alt="Instagram" /></a>
                        <a className="iconNotUnderline" href="https://www.youtube.com/@FerventFerment" target='_blank' rel='noreferrer'><img className="headerSocial_youtube" src={incon_youtube} alt="YouTube" /></a>
                        <a className="iconNotUnderline" href="https://www.tiktok.com/@ferventferment" target='_blank' rel='noreferrer'><img className="headerSocial_tiktok" src={icon_tiktok} alt="TikTok" /></a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header